import { DownloadOutlined } from "@ant-design/icons";
import { notification, Tooltip } from "antd";
import { ENTITY_TYPE, ZEE_CLIENT } from "constants/phase";
import { noDownloadStreams } from "constants/v2/streamConstants";
import { createDownloadLink, createPresignedDownloadLink } from "helpers";
import $ from "jquery";
import React, { useCallback, useState } from "react";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import { useOutletContext } from "react-router-dom";

import AlertDialog from "../../../components/common/Modals/AlertDialog";
import amplitude from "../../../externals/amplitude";
import defaultThumbNail from "../../../images/defaulThumb.png";
import { CloseModal } from "../../icons";
import AntdSpin from "../AntdSpinner/antd-spinner";
import ManageAccess from "../ManageAccess/manageAccess";
const PreviewDialog = ({
  modalIsOpen,
  clipUrl,
  imageUrl,
  slateUrl,
  setIsOpen,
  clipTitle,
  streamId,
  setAlertMessage,
  setIsAlertOpen,
  isAlertOpen,
  alertMessage,
  duration,
  hideDownloadBtn,
  clip,
  type,
  isEditedClip = false,
}) => {
  const { clientSetting, entityId, entityType, getDownloadVideoStatus, getDownloadVideo, getCloudPreSignedURL } =
    useOutletContext();
  const [downloadLoder, setDownloadLoder] = useState(false);
  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]); // setIsOpen is stable but adding it avoids lint warnings

  $(document).ready(function () {
    $("video").bind("contextmenu", function () {
      if (clientSetting?.permissions?.isProcessingLimit && entityType === ENTITY_TYPE.WORKSPACES) return false;
    });
  });

  const handleDownloadError = useCallback(
    (value) => {
      const message = value?.data?.message || value?.error?.message || "Something went wrong";

      if (value?.data?.limitError) {
        setIsAlertOpen(true);
        setAlertMessage(message);
        closeModal();
      } else {
        notification["error"]({ message });
      }
    },
    [closeModal, setAlertMessage, setIsAlertOpen],
  );

  const handleDownloadSuccess = useCallback(
    async (entityId, streamId) => {
      await getDownloadVideoStatus({ entityId, streamId });
      amplitude.logEvent("clip_downloaded", { page: "clip" });
    },
    [getDownloadVideoStatus],
  );

  const downloadWithPresignedUrl = useCallback(
    async (clip) => {
      try {
        const isProcessingLimit = clientSetting?.permissions?.isProcessingLimit;
        const isWorkspace = entityType === ENTITY_TYPE.WORKSPACES;
        const isProcessingWorkspace = isProcessingLimit && isWorkspace;

        const payloadData = isProcessingWorkspace
          ? {
              contentId: clip._id,
              contentType: type || "clip",
              userId: localStorage.getItem("__uid"),
              title: clipTitle ? clipTitle : undefined,
              url: clipUrl,
              streamId,
              duration,
              type: type || "clip",
              entityId: entityId,
              ...(isEditedClip ? { isEditedClip } : {}),
            }
          : {
              url: clipUrl,
              streamId: streamId,
              entityId,
            };

        const payload = isProcessingWorkspace
          ? await getDownloadVideo(payloadData)
          : await getCloudPreSignedURL(payloadData);

        const { value } = payload;
        if (value?.data?.url) {
          createPresignedDownloadLink(value?.data?.url);
          if (isProcessingWorkspace) {
            handleDownloadSuccess(entityId, streamId);
          }
        } else {
          throw value;
        }
      } catch (error) {
        throw error;
      }
    },
    [
      clientSetting?.permissions?.isProcessingLimit,
      entityType,
      type,
      clipTitle,
      clipUrl,
      streamId,
      duration,
      entityId,
      getDownloadVideo,
      getCloudPreSignedURL,
      handleDownloadSuccess,
      isEditedClip,
    ],
  );

  const downloadVideo = useCallback(async () => {
    amplitude.logEvent("clip_download_clicked");
    setDownloadLoder(true);
    try {
      if (clientSetting?.permissions?.allowDirectDownload) {
        createDownloadLink(clipUrl);
      } else {
        await downloadWithPresignedUrl(clip);
      }
    } catch (error) {
      handleDownloadError(error);
    } finally {
      setDownloadLoder(false);
    }
  }, [clientSetting?.permissions?.allowDirectDownload, clipUrl, downloadWithPresignedUrl, clip, handleDownloadError]);

  const getControlsList = () => {
    if (clientSetting.clientType === ZEE_CLIENT) {
      return "";
    } else if (type === "highlight") {
      return "nodownload"; // Hide the download and playbackspeed options
    } else {
      return "nodownload noplaybackrate";
    }
  };

  return (
    <>
      <AlertDialog
        alertModel={isAlertOpen}
        content={alertMessage}
        oncloseAlertModel={() => {
          setIsAlertOpen(false);
        }}
      />
      <Modal
        isOpen={modalIsOpen}
        ariaHideApp={false}
        onRequestClose={closeModal}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-xl modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            {/* <h5 className="react-modal-title">Clip Preview</h5> */}
            <h5 className="react-modal-title word-break-two title_Pascal">
              <Tooltip title={clipTitle ? clipTitle : ""}>{clipTitle ? clipTitle : ""}</Tooltip>
            </h5>
            <div>
              <ManageAccess
                value={
                  !imageUrl &&
                  !slateUrl &&
                  !hideDownloadBtn &&
                  !noDownloadStreams.includes(streamId) &&
                  (clientSetting?.permissions?.downloadClipButton ||
                    clientSetting?.permissions?.downloadHighlightButton)
                }
              >
                <Tooltip title="Download">
                  <button className="btn btn-white download-video-btn" onClick={() => downloadVideo()}>
                    <AntdSpin spin={downloadLoder}>
                      <DownloadOutlined style={{ fontSize: "25px" }} />
                    </AntdSpin>
                  </button>
                </Tooltip>
              </ManageAccess>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </div>
          <div className="react-modal-body">
            <ManageAccess value={imageUrl}>
              <div className="image-preview-modal-container mx-auto text-center">
                <img src={imageUrl} alt="Image Preview" className="" />
              </div>
            </ManageAccess>
            <ManageAccess value={!imageUrl}>
              <div className="video-preview" width="100%" height="100%">
                <ReactPlayer
                  url={clipUrl ? clipUrl : slateUrl}
                  controls
                  config={{
                    file: {
                      attributes: {
                        controlsList: getControlsList(),
                        poster: defaultThumbNail,
                        disablePictureInPicture: true,
                        ...(clientSetting?.permissions?.isHideRightClick && {
                          onContextMenu: (e) => e.preventDefault(),
                        }), // Conditionally include onContextMenu based condition to prevent right click on video player
                      },
                    },
                  }}
                  playing={true}
                  width="100%"
                  height="100%"
                />
              </div>
            </ManageAccess>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default PreviewDialog;
